goog.provide("shadow.js.shim.module$$mui$material$InputLabel$default");
shadow.js.shim.module$$mui$material$InputLabel$default = shadow.js.shim.module$$mui$material$InputLabel.default;
